import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedCdatstussReducer(state = initialState.selectedCdstatuss, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_CDSTATUSS_SUCCESS:
      return action.selectedCdstatuss;
    default:
      return state;
  }
}
